export class Fruizione {
    id?: number;
    name?: string;
    selected? : boolean = false;
    constructor () {

    }

}
